import React from 'react';
import { Home, Search, ShoppingCart, Heart, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const MobileBottomNav = ({ 
  cartCount = 0, 
  wishlistCount = 0, 
  onCartClick, 
  onAuthClick, 
  onSearchClick,
  onHomeClick,
  onWishlistClick 
}) => {
  const { isAuthenticated, user } = useAuth();

  const navItems = [
    {
      id: 'home',
      icon: Home,
      label: 'Home',
      onClick: onHomeClick,
      badge: null
    },
    {
      id: 'search',
      icon: Search,
      label: 'Search',
      onClick: onSearchClick,
      badge: null
    },
    {
      id: 'cart',
      icon: ShoppingCart,
      label: 'Cart',
      onClick: onCartClick,
      badge: cartCount > 0 ? cartCount : null
    },
    {
      id: 'wishlist',
      icon: Heart,
      label: 'Wishlist',
      onClick: onWishlistClick,
      badge: wishlistCount > 0 ? wishlistCount : null
    },
    {
      id: 'account',
      icon: User,
      label: isAuthenticated ? 'Account' : 'Sign In',
      onClick: onAuthClick,
      badge: null,
      isActive: isAuthenticated
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 sm:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={item.onClick}
              className="relative flex flex-col items-center justify-center flex-1 h-full py-2 text-gray-600 dark:text-gray-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors"
              aria-label={item.label}
            >
              <div className="relative">
                <Icon className={`w-5 h-5 ${item.isActive ? 'text-teal-600 dark:text-teal-400' : ''}`} />
                {item.badge && (
                  <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] flex items-center justify-center bg-rose-500 text-white text-xs font-bold rounded-full px-1">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-xs mt-1 ${item.isActive ? 'text-teal-600 dark:text-teal-400 font-medium' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
      
      {/* Safe area spacer for iOS devices - using inline styles instead of jsx attribute */}
    </nav>
  );
};

export default MobileBottomNav;
